import { ReactNode } from 'react'
import { ArticleFlat } from 'types'
import { useArticle } from 'hooks/queries/articles/useArticle'

interface Props {
  articleId?: string
  children: (article: ArticleFlat | undefined) => ReactNode
}

const WithArticle = ({ articleId, children }: Required<Props>) => {
  const { data } = useArticle(articleId)

  return <>{children(data?.article)}</>
}

const NoArticle = ({ children }: { children: (article: ArticleFlat | undefined) => ReactNode }) => {
  return <>{children(undefined)}</>
}

export const MaybeWithArticle = ({ articleId, children }: Props) => {
  if (!!articleId) {
    return <WithArticle articleId={articleId}>{children}</WithArticle>
  }

  return <NoArticle>{children}</NoArticle>
}
